import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutoLoginComponent } from './auth/auto-login/auto-login.component';
import { ForbiddenComponent } from './auth/forbidden/forbidden.component';
import { SettingsComponent } from './settings/settings.component';

import { SelectStoreTypeComponent } from './profiles/dashboard-shell/business-settings/store/select-store-type/select-store-type.component';
import { UnauthorizedComponent } from './auth/unauthorized/unauthorized.component';
import { ApplicationRouteSegments } from './shared/enums/enums';
import { ExpiredSessionComponent } from './shared/popups/expired-session/expired-session.component';
import { InvitationComponent } from './profiles/dashboard-shell/invitation-management/invitation/invitation.component';
import { ScePromotionComponent } from './shared/popups/sce-promotion/sce-promotion.component';
import {AuthGuard} from './auth/auth.guard/auth.guard';
import {ProfilesResolver} from './profiles/profiles.resolver/profiles.resolver';

const routes: Routes = [
  {
    path: '',
    redirectTo: `${ApplicationRouteSegments.profile}/${ApplicationRouteSegments.profileSelect}`,
    pathMatch: 'full',
  },

  /*secured routes*/
  /*todo unite routes under one authGuard and resolver*/
  {
    path: ApplicationRouteSegments.profile,
    loadChildren: () => import('./profiles/profiles.module').then(m => m.ProfilesModule),
    canActivate: [AuthGuard],
  },
  {
    path: ApplicationRouteSegments.onboarding,
    loadChildren: () => import('./onboarding/onboarding.module').then((m) => m.OnboardingModule),
    canActivate: [AuthGuard],
    resolve: {
      profiles: ProfilesResolver,
    },
  },
  {
    path: ApplicationRouteSegments.settings,
    component: SettingsComponent,
    canActivate: [AuthGuard],
    resolve: {
      profiles: ProfilesResolver,
    },
  },

  /*unsecured routes*/
  {
    path: ApplicationRouteSegments.autologin,
    component: AutoLoginComponent,
  },
  {
    path: ApplicationRouteSegments.unauthorized,
    component: UnauthorizedComponent,
  },
  {
    path: ApplicationRouteSegments.forbidden,
    component: ForbiddenComponent,
  },
  {
    path: ApplicationRouteSegments.selectStore,
    component: SelectStoreTypeComponent,
  },
  {
    path: ApplicationRouteSegments.invitation,
    data: {
      bypassAutoLogin: true,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: ':id',
      },
      {
        path: ':id',
        component: InvitationComponent,
        pathMatch: 'full',
      },
    ],
  },

  /*Common pop-up routes*/
  {
    path: 'session_error',
    component: ExpiredSessionComponent,
    outlet: 'popup',
  },
  {
    path: 'sce-promotion/:profileId',
    component: ScePromotionComponent,
    outlet: 'popup',
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
